import { type CustomTooltipProps } from "ag-grid-react"
import { Card, CardContent, CardHeader, CardTitle } from "~/components/reusable/Card"
import {
  HISTORIC_DATA_LABEL,
  type ConfidenceLevel,
  confidenceConfig,
} from "~/utils/sizeSplitConfidence"

import HeaderTooltip from "./HeaderTooltip"

interface SizeSplitConfidenceTooltipProps extends CustomTooltipProps {
  sizeSplitTrust?: string | null
  isHistoric?: boolean
}

export default function SizeSplitConfidenceTooltip(props: SizeSplitConfidenceTooltipProps) {
  if (props.location === "header") return <HeaderTooltip {...props} />

  const trust = props.isHistoric
    ? HISTORIC_DATA_LABEL
    : (props.sizeSplitTrust as ConfidenceLevel | null | undefined)
  if (!trust) return null

  const config = confidenceConfig[trust]

  return (
    <div className="bg-base w-[300px] mr-6 z-10">
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Size Split Confidence: {trust}</CardTitle>
        </CardHeader>
        <CardContent className="text-fg-muted paragraph-sm space-y-2">
          <p>{config.description}</p>
          <p>
            <span className="font-medium text-fg-base">Recommendation</span>
            <br />
            {config.recommendation}
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
